export default "__VITE_ASSET__D$_82LQx__"